import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import x from '../../../images/x-icon_black_blade.svg';

// * Styling for the Blade menu is inside of src/themes/bladeStyles

export const Wrapper = styled.div`
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
`;

export const Header = styled.div`
  width: 100%;
  outline: none;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.25rem;
  border-bottom: 2px solid ${themeGet('colors.light-border-grey')};
  position: relative;

  p {
    margin: 0;
    font-size: 16px;
    letter-spacing: -0.06px;
    color: ${themeGet('colors.pc-red', '#E1251B')};
  }

  ${Wrapper}.application-blade & {
    margin-bottom: 1rem;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3) none repeat scroll 0% 0%;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: opacity 0.3s ease 0s;
  transition: ${({ isOpen }) =>
    isOpen
      ? 'opacity 0.3s ease 0s'
      : 'opacity 0.3s ease 0s, transform 0s ease 0.3s'};
  transform: ${({ isOpen }) => (isOpen ? '' : 'translate3d(100%, 0px, 0px)')};
  top: 0px;
  left: 0px;
  right: 0px;
`;

export const CloseBtn = styled.button.attrs(() => ({
  type: 'button',
}))`
  &::after {
    content: '';
    display: block;
    color: ${themeGet('colors.black')};
    height: 20px;
    width: 20px;
    background-image: url(${x});
    background-repeat: no-repeat;
    background-size: cover;
  }

  span {
    clip: rect(0px, 0px, 0px, 0px);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

export const Logo = styled.img`
  width: 100%;
  max-width: 120px;
  height: 100%;
  max-height: 48px;
`;

export const RightSideHeader = styled.div`
  display: flex;
`;
